export default __webpack_public_path__ + "static/media/reload.3c6f919e.svg";